export enum SavedLocationSaveResult {
  Warning = 'Warning',
  Error = 'Error'
}
